import React, { useEffect, useState } from "react";
import withStyles from "@material-ui/styles/withStyles";
import { Paper, Typography, Grid, Chip, Tooltip, Modal, CircularProgress } from "@material-ui/core";

import { styles } from "./LastReadings.styles";

import { getSensorLastReadings, selectLastReadings, selectSelectedProject } from "../dashboardSlice";
import { getStructure, selectStructure } from "../../structure/structureSlice";
import { useDispatch, useSelector } from "react-redux";
import { usePrevious } from "../../../common/hooks/usePrevious";
import TemperatureGauge from "./components/TemperatureGauge";
import HumidityGauge from "./components/HumidityGauge";
import SensorIcon from "../../../common/components/displays/SensorIcon";
import BatteryGauge from "./components/BatteryGauge";
import moment from "moment";
import { FiAlertTriangle } from "react-icons/fi";
import HumidityChart from "../../../common/charts/HumidityChart";
import TemperatureChart from "../../../common/charts/TemperatureChart";
import RelayChart from "../../../common/charts/RelayChart";
import WaterLevelChart from "../../../common/charts/WaterLevelChart";
import BatteryChart from "../../../common/charts/BatteryChart";

import { getSensorReadings, selectSensorReadings, selectLoader } from "../../structure/structureSlice";

const getSensors = (structure, readings) => {
  let sensors = [];
  (structure || []).forEach((zone) => {
    (zone?.boxs || []).forEach((box) => {
      (box?.sensors || []).forEach((sensor) => {
        sensors.push({
          ...sensor,
          box,
          zone,
          readings: readings.find((item) => item.code === sensor.code) || {},
        });
      });
    });
  });
  return sensors;
};

function LastReadings({ classes }) {
  const dispatch = useDispatch();
  const structure = useSelector(selectStructure);
  const readings = useSelector(selectLastReadings);
  const selectedProject = useSelector(selectSelectedProject);
  const prevSelectedProject = usePrevious(selectedProject);
  const [sensors, setSensors] = useState([]);
  const [modalReadingsOpen, setModalReadingsOpen] = useState(false);
  const [selectedSensor, setSelectedSensor] = useState();

  const loading = useSelector(selectLoader);
  const selectedSensorReadings = useSelector(selectSensorReadings);

  const setGroupDate = (date) => {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), 0, 0);
  };

  const groupReadingsRelay = (readings, deviance = 5) => {
    //let deviance = 5;
    let current = null;
    let r = [];
    if (readings && readings.length > 0) {
      readings.forEach((item) => {
        if (!current) {
          current = item.value;
          r.push(item);
          return;
        }
        if (
          parseInt(item.value) > parseInt(current) + deviance ||
          parseInt(item.value) < parseInt(current) - deviance
        ) {
          // console.log('item: %s current: %s', item.value, current);
          //if (item.value !== current) {
          current = item.value;
          r.push(item);
        }
      });
      r.push(readings[readings.length - 1]);
    }
    return r;
  };

  const groupReadingsRelay2 = (readings) => {
    let current = null;
    let r = [];
    if (readings && readings.length > 0) {
      readings.forEach((item) => {
        if (!current) {
          current = item.value;
          r.push(item);
          return;
        }
        if (parseInt(item.value) !== parseInt(current)) {
          // console.log('item: %s current: %s', item.value, current);
          //if (item.value !== current) {
          current = item.value;
          r.push(item);
        }
      });
      r.push(readings[readings.length - 1]);
    }
    return r;
  };

  const groupReadings = (readings) => {
    console.log("------------ groupReadings: %o", readings);
    let r = [];
    r.push(readings[0]);
    let sum = 0,
      count = 0,
      date = null;
    readings.forEach((item) => {
      let d = new Date(item.date);
      if (!date) {
        date = setGroupDate(d);
      } else {
        if (date.getHours() !== d.getHours()) {
          r.push({
            date: date,
            value: (sum / count).toFixed(1),
          });
          date = setGroupDate(d);
          sum = 0;
          count = 0;
        }
      }
      sum += parseFloat(item.value);
      count++;
    });
    //adicionar o ultimo e o primeiro reading
    r.push(readings[readings.length - 1]);

    console.log("------------ r: %o", r);
    return r;
  };

  useEffect(() => {
    if (!structure || structure.length === 0 || prevSelectedProject?.id !== selectedProject?.id) {
      dispatch(getStructure(selectedProject));
    }
    let readingsLoop = setInterval(() => {
      if (structure && structure.length > 0 && sensors && sensors.length > 0) {
        const sensorCodes = sensors.map((item) => item.code);
        dispatch(getSensorLastReadings(selectedProject, sensorCodes.join(",")));
      }
    }, 10000);
    return () => {
      clearInterval(readingsLoop);
    };
    // eslint-disable-next-line
  }, [selectedProject]);

  useEffect(() => {
    if (structure && structure.length > 0) {
      setSensors(getSensors(structure, readings));
    }
    // eslint-disable-next-line
  }, [structure, readings]);

  useEffect(() => {
    if (sensors && sensors.length > 0 && readings.length === 0) {
      const sensorCodes = sensors.map((item) => item.code);
      dispatch(getSensorLastReadings(selectedProject, sensorCodes.join(",")));
    }
    // eslint-disable-next-line
  }, [sensors]);

  const wasXminutesAgo = (date, minutes) => {
    if (!date) {
      return false;
    }
    return moment(date) < moment(new Date()).subtract("minutes", minutes);
  };

  return (
    <Paper className={classes.root}>
      <Grid container spacing={1}>
        {sensors &&
          sensors.map((sensor) => {
            return (
              <Grid
                item
                xs={12}
                key={sensor.code}
                onClick={() => {
                  setSelectedSensor(sensor);
                  dispatch(getSensorReadings(selectedProject, sensor.code, sensor.id, sensor.type));
                  setModalReadingsOpen(true);
                }}
              >
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Typography variant="h5" className={classes.title}>
                      <SensorIcon type={sensor.type} /> {sensor.designation}
                    </Typography>
                    <Typography variant="h6" className={classes.description}>
                      <Chip size="small" color="secondary" label={sensor.code} />
                      <br />
                      {sensor.description}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Tooltip
                      title={
                        <div>
                          {"Last Reading: " + moment(sensor.readings?.date).fromNow()}
                          <br />
                          {"(" + moment(sensor.readings?.date).format("YYYY-MM-DD[T]HH:mm:ss") + ")"}
                        </div>
                      }
                      placement="right-start"
                    >
                      <div className={classes.readingBox}>
                        {wasXminutesAgo(sensor.readings?.date, 30) && (
                          <FiAlertTriangle color="#e7bb36" className={classes.alertIcon} />
                        )}
                        {sensor.type === "TEMPERATURE" && sensor.readings?.value && (
                          <TemperatureGauge temperatureValue={sensor.readings?.value} fontSize={18} height={120} />
                        )}
                        {sensor.type === "HUMIDITY" && sensor.readings?.value && (
                          <HumidityGauge humidityValue={sensor.readings?.value} fontSize={18} height={120} />
                        )}
                        {sensor.type === "BATTERY" && sensor.readings?.value && (
                          <BatteryGauge batteryValue={sensor.readings?.value} fontSize={18} height={120} />
                        )}
                        {sensor.type === "RELAY" && sensor.readings?.value && (
                          <Typography variant="h5" className={classes.relayInfo}>
                            {sensor.readings?.value}
                          </Typography>
                        )}
                        {sensor.type === "WATERLEVEL" && sensor.readings?.value && (
                          <HumidityGauge humidityValue={sensor.readings?.value * 100} fontSize={18} height={120} />
                        )}
                      </div>
                    </Tooltip>
                  </Grid>
                  <Grid item xs={12}>
                    <div className={classes.separator}></div>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}

        {selectedSensorReadings && selectedSensor && (
          <Modal open={modalReadingsOpen} onClose={() => setModalReadingsOpen(false)}>
            <div className={classes.modal}>
              {selectedSensor.type === "TEMPERATURE" && !loading && (
                <TemperatureChart data={groupReadings(selectedSensorReadings)} />
              )}
              {selectedSensor.type === "HUMIDITY" && !loading && (
                <HumidityChart data={groupReadings(selectedSensorReadings)} />
              )}
              {selectedSensor.type === "WATERLEVEL" && !loading && <WaterLevelChart data={selectedSensorReadings} />}
              {selectedSensor.type === "BATTERY" && !loading && <BatteryChart data={selectedSensorReadings} />}
              {selectedSensor.type === "RELAY" && !loading && (
                <RelayChart
                  data={selectedSensorReadings
                    // selectedSensor.model === "LATCH-RELAY"
                    //   ? groupReadingsRelay2(selectedSensorReadings)
                    //   : groupReadingsRelay(selectedSensorReadings)
                  }
                  sensor={selectedSensor}
                />
              )}
              {loading && <CircularProgress />}
            </div>
          </Modal>
        )}
      </Grid>
    </Paper>
  );
}

export default withStyles(styles)(LastReadings);
